import React, { useEffect, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import {
  aboutexpert1,
  aboutexpert2,
} from "../../../../CustomComponents/CustomValidation";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import FieldArea from "../../../../CustomComponents/FieldText";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import ReactSelect from "react-select";
import { useSelector } from "react-redux";
import CustomAddIndustry from "./ICustomAddIndustry";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import { waitforfewsecond } from "../../../../Common/FewCommonMethods";
import CustomReactQuill from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import AsteriskLabel from "../../../../Common/AsteriskLabel";

const formdatatomap = [
  { title: "I Am", name: "iam", placeholder: "I Am" },
  // { title: "National ID", name: "national_id", placeholder: 'Enter national ID no.' },
  {
    title: (<>Designation <AsteriskLabel /></>),
    name: "designation",
    placeholder: "Your Job designation",
  },
  {
    title: (<>Company Name <AsteriskLabel /></>),
    name: "company_name",
    placeholder: "Enter company name",
  },
  {
    title: (<>CR Number <AsteriskLabel /></>),
    name: "cr_number",
    placeholder: "Enter company CR no.",
  },
  {
    title: (<>Country of registration <AsteriskLabel /></>),
    name: "country_id",
    placeholder: "Select country",
  },
  {
    title: (<>Wathq verification <AsteriskLabel /></>),
    name: "wathq_verification",
    placeholder: "Enter Wathq verification no.",
  },
  { title: (<>Industries <AsteriskLabel /></>), name: "industries", placeholder: "Industries" },
  { title: (<>Tell About Yourself <AsteriskLabel /></>), name: "about", placeholder: "Enter bio" },
];

const IAboutYou = ({ formData, setFormData, nextPage, formdata }) => {
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const [country, setCountry] = useState("");
  const [selectCountry, setSelectCountry] = useState(formData?.country_index);
  const [im, setIm] = useState(formData?.iam || 1);
  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);
  const [loading, setLoading] = useState(false);

  const initialValues = {
    iam: formData?.iam || im,
    national_id: formData?.national_id,
    designation: formData?.designation,
    about: formData?.about,
    company_name: formData?.company_name,
    cr_number: formData?.cr_number,
    country_id: formData?.country_id,
    wathq_verification: formData?.wathq_verification,
    industries: formData?.industries,
  };

  useEffect(() => {
    setCountry(countrylist);
  }, [countrylist]);

  const handleSubmit = async (values) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));
    nextPage();
    setLoading(false);
  };

  const handleWorkingcountryChange = (selectedOption, formik) => {
    setSelectCountry(selectedOption);
    formik.setValues({
      ...formik.values,
      country_index: selectedOption,
      country_id: selectedOption.value,
    });
    // setFormData((prevData) => ({
    //   ...prevData,
    //   'country_id': selectedOption.value
    // }));
  };

  const handleChange = (value) => {
    setIm(value);
    setFormData((prevData) => ({
      ...formdata,
      iam: value,
    }));
  };

  return (
    <div className="row about-row">
      <div className="col-lg-4    about-left">
        <h6>
          <span className="about-step"> 01/{im == 1 ? "9" : "07"}</span>
          <span>About you</span>
        </h6>
        <h2>Join as an Expert / Company</h2>
        <p>Fill up the form to find opportunities on Urxprt</p>
      </div>
      <div className="col-lg-6   about-right">
        <Formik
          initialValues={initialValues}
          validationSchema={im == 2 ? aboutexpert2 : aboutexpert1}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {(formik) => (
            <Form>
              <div>
                {formdatatomap.map((prop, key) => {
                  if (prop.name == "iam") {
                    return (
                      <div key={key} className="form-group">
                        <h6 className="prop-title">{prop.title} </h6>
                        <div className="checkbox-label ">
                          <label className="checkbox-container">
                            <Field
                              type="radio"
                              checked={im == 1 ? "checked" : ""}
                              onClick={() => {
                                handleChange(1);
                              }}
                              name={prop.name}
                              value="1"
                            />
                            <span className="checkmark">An Individual</span>
                          </label>
                          <label className="checkbox-container">
                            <Field
                              type="radio"
                              checked={im == 2 ? "checked" : ""}
                              onClick={() => {
                                handleChange(2);
                              }}
                              name={prop.name}
                              value="2"
                            />
                            <span className="checkmark">A Company</span>
                          </label>
                        </div>
                        <ErrorMessage
                          name={prop.name}
                          component="div"
                          className="error"
                        />
                      </div>
                    );
                  }
                  if (prop.name == "about") {
                    if (prop.name == "about" && im == 1) {
                      return (
                        <div className="form-group tell-about-margin">
                          <CustomReactQuill
                            value={formik.values.about}
                            formik={formik}
                            name={prop.name}
                            title={(<>Tell About Yourself <AsteriskLabel /></>)}
                          />
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                            style={{ color: "red" }}
                          />
                        </div>
                      );
                    }
                    if (prop.name == "about" && im == 2) {
                      return (
                        <FieldArea
                          title={(<>About the company <AsteriskLabel /></>)}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    return null;
                  }

                  if (prop.name == "national_id") {
                    if (prop.name == "national_id" && im == 1) {
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    return null;
                  }

                  if (prop.name == "designation") {
                    if (prop.name == "designation" && im == 1) {
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    return null;
                  }

                  if (prop.name == "company_name") {
                    if (prop.name == "company_name" && im == 2) {
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    return null;
                  }

                  if (prop.name == "cr_number") {
                    if (prop.name == "cr_number" && im == 2) {
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    return null;
                  }
                  if (prop.name == "country_id") {
                    if (prop.name == "country_id" && im == 2) {
                      return (
                        <>
                          <div className="form-group">
                            <label>{prop.title}</label>
                            <ReactSelect
                              options={
                                Array.isArray(country) &&
                                country.map((lang) => ({
                                  value: lang.id,
                                  label: lang.title,
                                }))
                              }
                              placeholder="Select country"
                              value={selectCountry}
                              onChange={(options) => {
                                handleWorkingcountryChange(options, formik);
                              }}
                            />
                            <ErrorMessage
                              name={"country_id"}
                              component="div"
                              className="error"
                            />
                          </div>
                        </>
                      );
                    }
                    return null;
                  }
                  if (prop.name == "wathq_verification") {
                    if (prop.name == "wathq_verification" && im == 2) {
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    }
                    return null;
                  }
                  if (prop.name == "industries") {
                    if (prop.name == "industries" && im == 2) {
                      return (
                        <>
                          <CustomAddIndustry
                            formData={formData}
                            setFormData={setFormData}
                            formik={formik}
                          />
                          <ErrorMessage
                            name={"industries"}
                            component="div"
                            className="error"
                          />
                        </>
                      );
                    }
                    return null;
                  }

                  return (
                    <FieldInput
                      title={prop.title}
                      name={prop.name}
                      placeholder={prop.placeholder}
                      key={key}
                    />
                  );
                })}
                <div className="profile">
                  <h6 className="mb-0">What make a great profile?</h6>
                  <p>Write about your expertise</p>
                  <p>Write about your work experience</p>
                  <p>Tell why you are the best choice.</p>
                </div>
                <div className="button-container ">
                  <button
                    className="next-button"
                    type="submit"
                    onClick={formik.handleSubmit}
                  >
                    {loading ? (
                      <LoginLoaderButton />
                    ) : (
                      <>
                        Next
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                          alt=""
                        />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default IAboutYou;
